import Icon from "@booking/components/atoms/media/Icon";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

import { PHONE_LINK, PHONE_NUMBER_DISPLAY } from "../utils/constants";
import { formatDate } from "../utils/dateUtils";
import formStyles from "./CreateYourOwnForm.module.css";
import { CreateYourOwnPersonalFormData } from "./CreateYourOwnPersonalForm";
import styles from "./CreateYourOwnResult.module.css";
import { CreateYourOwnTravelFormData } from "./CreateYourOwnTravelForm";

interface CreateYourOwnSuccessViewProps {
  travelDetails: CreateYourOwnTravelFormData | null;
  personalDetails: CreateYourOwnPersonalFormData | null;
  venueName?: string;
}

function CreateYourOwnSuccessView(props: CreateYourOwnSuccessViewProps) {
  const { travelDetails, personalDetails, venueName } = props;

  return (
    <div className={styles.wrapper}>
      <div className={formStyles.summaryHeader}>
        <h3>{venueName || "Golf Break"}</h3>
        <p>
          {travelDetails?.nights || "1"} night
          {travelDetails?.nights !== "1" ? "s" : ""},{" "}
          {travelDetails?.rounds || "1"} round
          {travelDetails?.rounds !== "1" ? "s" : ""}
          {travelDetails?.arrival_date && (
            <> on {formatDate(travelDetails.arrival_date)}</>
          )}
        </p>
      </div>

      <section>
        <div className={styles.checkmarkContainer}>
          <Icon name={faCircleCheck} />
        </div>

        <article>
          <h2>Thank you, {personalDetails?.first_name?.split(" ")[0]}</h2>

          <p>
            We've received your enquiry, thanks! You are now just moments away
            from a great golf holiday.
          </p>

          <p>
            The next step is one of our Golf Travel Experts (who will have
            played the golf courses) will be in touch to organise the perfect
            trip for you.
          </p>

          <p>
            If your enquiry is urgent, we recommend you call{" "}
            <a href={PHONE_LINK}>{PHONE_NUMBER_DISPLAY}</a> where our Golf
            Travel Experts can help you within 60 seconds.
          </p>
        </article>
      </section>
    </div>
  );
}

export default CreateYourOwnSuccessView;
export { CreateYourOwnSuccessView, type CreateYourOwnSuccessViewProps };
